import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {NotificationModule} from '@progress/kendo-angular-notification';
import {CompartilhadoModule} from '../../compartilhado/compartilhado.module';
import {ApplicationPipesModule} from '../../pipes/application-pipes.module';
import {ConstantsService} from '../../fidelidade/ConstantsService';
import {TelaNovoPedidoV3Component} from './tela-novo-pedido-v3.component';
import {CentralPedidosDialogComponent} from './central-pedidos-dialog/central-pedidos-dialog.component';

@NgModule({
  declarations: [
    TelaNovoPedidoV3Component,
    CentralPedidosDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    NotificationModule,
    CompartilhadoModule,
    ApplicationPipesModule
  ],
  exports: [
    TelaNovoPedidoV3Component
  ],
  providers: [
    ConstantsService
  ]
})
export class TelaNovoPedidoV3Module {
}
